module.exports = __webpack_public_path__ + "static/media/B7.a625471e.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B7.png
// module id = 886
// module chunks = 0